export const CONFIRMATION_DIALOG__DELETE_FOOTER_LINK_CATEGORY = 'CONFIRMATION_DIALOG__DELETE_FOOTER_LINK_CATEGORY';
export const CONFIRMATION_DIALOG__DELETE_FOOTER_LINK = 'CONFIRMATION_DIALOG__DELETE_FOOTER_LINK';
export const CONFIRMATION_DIALOG__DELETE_FOOTER_LINK_TRANSLATION = 'CONFIRMATION_DIALOG__DELETE_FOOTER_LINK_TRANSLATION';
